import { BASE_URL } from '../../../../../utils/config.base-url'

export const URL_ENDPOINT_THIET_BI_PHONG_HOP = `${BASE_URL}/thiet-bi-phong-hop`
export const THIET_BI_PHONG_HOP_PREFIX_URL = '/thiet-bi-phong-hop'
